import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source, true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(source)).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
|-------------------------------------------------------------------------------
| Select Input
|-------------------------------------------------------------------------------
|
| The following compound component attempts to implement a number of core
| select behaviours:
|
|  - Focus/active states for Select
|  - Keyboard navigation for Menu, through Select actions
|  - Indicators for: Dropdown, Clear, Loading
|  - Rendering the selected Values inside the Input, either as single or tags
|  - Aria compliance for input (WIP)
|
| The component also attempts to be transparent with data & handlers.
|
|  - When the `onKeyDown` prop is given manually, then it is possible to
|    override default behaviours and take complete control over interactions.
|  - When the `value` prop is given manually, it is given over to the internal
|    state management to override the current value.
|
*/
import { styled, StyleSheet } from '@rexlabs/styling';
import { TextInput } from '@rexlabs/text-input';
import React, { Component } from 'react';
import { autobind } from 'core-decorators';
import Types from 'prop-types';
import _ from 'lodash';
import { ComponentPropType, NumOrStringPropType, SelectModelPropType } from '../utils/custom-prop-types';
import mixins from '../utils/style-mixins';
import KEY_CODES from '../utils/key-codes';
import isPrimaryMouseButton from '../utils/is-primary-mouse-button';
import isTouchEvent from '../utils/is-touch-event';
import LoadingIndicator from './input-indicators/loading';
import DropdownIndicator from './input-indicators/dropdown';
import ClearIndicator from './input-indicators/clear';
import Value from './value';
import selectController from './controller-hoc';
var SelectInput = (_dec = styled(StyleSheet({
  wrapper: {
    width: '100%'
  },
  container: {
    padding: 0,
    display: 'flex',
    alignItems: 'stretch',
    flexWrap: 'nowrap'
  },
  indicators: _objectSpread({}, mixins.flexVerticalCenter),
  input: {
    padding: '0.25em'
  },
  cosmetic: _objectSpread({
    display: 'flex',
    alignItems: 'center',
    padding: '0.25em'
  }, mixins.truncate),
  isMenuOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  notSearchableContainer: {
    cursor: 'pointer'
  },
  notSearchableInput: {
    cursor: 'pointer',
    caretColor: 'transparent'
  }
})), selectController(_class = _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectInput, _Component);

  function SelectInput(props) {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectInput)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this, props]).call(_context, args)));

    if (props.value) {
      props.select.actions.setValue(props.value);
    }

    return _this;
  }

  _createClass(SelectInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.updateValue(this.props.value, nextProps.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevSelect = _ref.select;
      var _this$props = this.props,
          select = _this$props.select,
          autoBlur = _this$props.autoBlur;

      if (autoBlur && prevSelect.state.selected !== select.state.selected) {
        this.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          styles = _this$props2.styles,
          select = _this$props2.select,
          LoadingIndicator = _this$props2.LoadingIndicator,
          loadingIndicatorProps = _this$props2.loadingIndicatorProps,
          DropdownIndicator = _this$props2.DropdownIndicator,
          dropdownIndicatorProps = _this$props2.dropdownIndicatorProps,
          ClearIndicator = _this$props2.ClearIndicator,
          clearIndicatorProps = _this$props2.clearIndicatorProps,
          SuffixIcon = _this$props2.SuffixIcon,
          Value = _this$props2.Value,
          placeholder = _this$props2.placeholder,
          value = _this$props2.value,
          isClearable = _this$props2.isClearable,
          name = _this$props2.name,
          autoFocus = _this$props2.autoFocus,
          required = _this$props2.required,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          onChange = _this$props2.onChange,
          onKeyDown = _this$props2.onKeyDown,
          autoBlur = _this$props2.autoBlur,
          isSearchable = _this$props2.isSearchable,
          allowCustomInput = _this$props2.allowCustomInput,
          shouldOpenOnFocus = _this$props2.shouldOpenOnFocus,
          shouldCloseOnBlur = _this$props2.shouldCloseOnBlur,
          shouldBackspaceRemove = _this$props2.shouldBackspaceRemove,
          shouldDeleteRemove = _this$props2.shouldDeleteRemove,
          shouldEscapeClearValue = _this$props2.shouldEscapeClearValue,
          shouldTabSelectValue = _this$props2.shouldTabSelectValue,
          shouldBlurResetInput = _this$props2.shouldBlurResetInput,
          shouldCloseResetInput = _this$props2.shouldCloseResetInput,
          shouldCloseOnSelect = _this$props2.shouldCloseOnSelect,
          shouldMenuOpen = _this$props2.shouldMenuOpen,
          onCleared = _this$props2.onCleared,
          props = _objectWithoutProperties(_this$props2, ["styles", "select", "LoadingIndicator", "loadingIndicatorProps", "DropdownIndicator", "dropdownIndicatorProps", "ClearIndicator", "clearIndicatorProps", "SuffixIcon", "Value", "placeholder", "value", "isClearable", "name", "autoFocus", "required", "disabled", "tabIndex", "onBlur", "onFocus", "onChange", "onKeyDown", "autoBlur", "isSearchable", "allowCustomInput", "shouldOpenOnFocus", "shouldCloseOnBlur", "shouldBackspaceRemove", "shouldDeleteRemove", "shouldEscapeClearValue", "shouldTabSelectValue", "shouldBlurResetInput", "shouldCloseResetInput", "shouldCloseOnSelect", "shouldMenuOpen", "onCleared"]);

      var isMenuOpen = select.state.isOpen;
      var styleOverrides = {
        wrapper: styles('wrapper').className,
        container: styles('container', {
          isMenuOpen: isMenuOpen,
          notSearchableContainer: !isSearchable
        }).className,
        input: styles('input', {
          notSearchableInput: !isSearchable
        }).className,
        cosmetic: styles('cosmetic').className
      };
      var showSelected = select.state.selected.length > 0 && !select.state.value;
      var singleValue = !showSelected && !select.state.multi ? null : React.createElement(Value, {
        multi: select.state.multi,
        option: select.state.selected[0],
        pluckLabel: select.helpers.pluckLabel
      });
      var canShowLoading = Boolean(LoadingIndicator && !disabled && select.state.isLoading);
      var canShowClear = Boolean(isClearable && (select.state.value || select.state.selected.length > 0) && !disabled && !select.state.isLoading);
      var canShowDropdown = Boolean(DropdownIndicator && select.state.options);
      var canShowIcon = Boolean(SuffixIcon && !canShowClear);
      return React.createElement(TextInput, _extends({
        autoComplete: "off"
      }, props, {
        styles: styleOverrides,
        name: name,
        value: select.state.value,
        cosmetic: singleValue,
        autoFocus: autoFocus,
        required: required,
        disabled: disabled,
        tabIndex: tabIndex,
        setRef: this.setRef,
        placeholder: showSelected ? '' : placeholder,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        containerProps: {
          onMouseDown: this.handleMouseDown,
          onTouchEnd: this.handleMouseDown
        },
        suffix: React.createElement("span", _extends({}, styles('indicators'), {
          onKeyDown: this.handleKeyDown
        }), canShowLoading && React.createElement(LoadingIndicator, loadingIndicatorProps), canShowClear && React.createElement(ClearIndicator, _extends({}, clearIndicatorProps, {
          disabled: disabled,
          onMouseDown: this.handleClear,
          onTouchEnd: this.handleClear
        })), canShowDropdown && React.createElement(DropdownIndicator, _extends({}, dropdownIndicatorProps, {
          disabled: disabled,
          isActive: select.state.isOpen || Boolean(select.state.value),
          onMouseDown: this.handleDropdown,
          onTouchEnd: this.handleDropdown
        })), canShowIcon && SuffixIcon)
      }));
    }
  }, {
    key: "setRef",
    value: function setRef(ref) {
      this.inputRef = ref;
    }
  }, {
    key: "blur",
    value: function blur() {
      this.inputRef && this.inputRef.blur();
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      var _this$props3 = this.props,
          select = _this$props3.select,
          shouldCloseResetInput = _this$props3.shouldCloseResetInput,
          shouldMenuOpen = _this$props3.shouldMenuOpen;

      if (select.state.isOpen) {
        select.actions.closeMenu();
        if (shouldCloseResetInput) select.actions.clearValue();
      } else if (shouldMenuOpen) {
        select.actions.openMenu();
      }
    }
  }, {
    key: "updateValue",
    value: function updateValue(prevValueProp, nextValueProp) {
      var select = this.props.select;
      var hasPropChanged = prevValueProp !== nextValueProp;
      if (hasPropChanged) select.actions.setValue(nextValueProp);
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props4 = this.props,
          select = _this$props4.select,
          onChange = _this$props4.onChange,
          isSearchable = _this$props4.isSearchable;

      if (!isSearchable) {
        event.stopPropagation();
        event.preventDefault();
        return;
      }

      if (onChange) onChange(event);
      if (event.defaultPrevented) return;
      select.actions.setValue(_.get(event, 'target.value'));
      select.actions.setIndex(0);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      var _this$props5 = this.props,
          select = _this$props5.select,
          onFocus = _this$props5.onFocus,
          isSearchable = _this$props5.isSearchable,
          shouldOpenOnFocus = _this$props5.shouldOpenOnFocus,
          shouldMenuOpen = _this$props5.shouldMenuOpen;

      if (isSearchable) {
        if (onFocus) onFocus(event);
        if (event.defaultPrevented) return;
      }

      event.stopPropagation();
      event.preventDefault();
      if (shouldOpenOnFocus && shouldMenuOpen) select.actions.openMenu();
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var _this$props6 = this.props,
          select = _this$props6.select,
          onBlur = _this$props6.onBlur,
          shouldBlurResetInput = _this$props6.shouldBlurResetInput,
          shouldCloseOnBlur = _this$props6.shouldCloseOnBlur;
      if (onBlur) onBlur(event);
      if (event.defaultPrevented) return;
      if (shouldCloseOnBlur) select.actions.closeMenu();
      if (shouldBlurResetInput) select.actions.clearValue();
    }
  }, {
    key: "handleClear",
    value: function handleClear(event) {
      var _this$props7 = this.props,
          select = _this$props7.select,
          disabled = _this$props7.disabled,
          onCleared = _this$props7.onCleared;

      if (!disabled && (isPrimaryMouseButton(event) || isTouchEvent(event))) {
        event.stopPropagation();
        event.preventDefault();
        select.actions.clearValue();
        select.actions.clearSelected();
        onCleared && _.isFunction(onCleared) && onCleared();
      }
    }
  }, {
    key: "handleDropdown",
    value: function handleDropdown(event) {
      var disabled = this.props.disabled;

      if (!disabled && (isPrimaryMouseButton(event) || isTouchEvent(event))) {
        event.stopPropagation();
        event.preventDefault();
        this.toggleMenu();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var keyCode = event.keyCode,
          shiftKey = event.shiftKey;
      var _this$props8 = this.props,
          select = _this$props8.select,
          onKeyDown = _this$props8.onKeyDown,
          isClearable = _this$props8.isClearable,
          shouldMenuOpen = _this$props8.shouldMenuOpen,
          shouldEscapeClearValue = _this$props8.shouldEscapeClearValue,
          shouldBackspaceRemove = _this$props8.shouldBackspaceRemove,
          shouldDeleteRemove = _this$props8.shouldDeleteRemove,
          shouldTabSelectValue = _this$props8.shouldTabSelectValue,
          shouldCloseOnSelect = _this$props8.shouldCloseOnSelect;

      if (onKeyDown) {
        // Note: We give the developer complete control over this handler when
        //       they call `event.preventDefault()`. eg Creating new options
        if (onKeyDown) onKeyDown(select.state.options[select.state.index], event);
        if (event.defaultPrevented) return;
      }

      switch (keyCode) {
        case KEY_CODES.BACKSPACE:
        case KEY_CODES.DELETE:
          var canRemove = shouldDeleteRemove && KEY_CODES.DELETE === keyCode || shouldBackspaceRemove && KEY_CODES.BACKSPACE === keyCode;

          if (!select.state.value && canRemove) {
            event.preventDefault();
            select.actions.popSelected();
          }

          return;

        case KEY_CODES.TAB:
          if (!shiftKey && select.state.isOpen && shouldTabSelectValue) {
            select.actions.pushIndexedToSelected();
          }

          return;

        case KEY_CODES.ENTER:
          if (select.state.isOpen && select.state.options.length > 0) {
            event.stopPropagation();
            select.actions.pushIndexedToSelected();
            select.actions.clearValue();
            if (shouldCloseOnSelect) select.actions.closeMenu();
          }

          return;

        case KEY_CODES.ESCAPE:
          if (select.state.isOpen) {
            // Note: Blocks the escape from closing other components. eg Modals
            event.stopPropagation();
            select.actions.closeMenu();
          } else if (isClearable && shouldEscapeClearValue && select.state.value) {
            event.stopPropagation();
            select.actions.clearValue();

            if (shouldMenuOpen) {
              select.actions.openMenu();
            }
          }

          return;

        case KEY_CODES.UP:
          if (select.state.isOpen) {
            select.actions.decrementIndex();
          } else if (shouldMenuOpen) {
            select.actions.openMenu();
          }

          break;

        case KEY_CODES.DOWN:
          if (select.state.isOpen) {
            select.actions.incrementIndex();
          } else if (shouldMenuOpen) {
            select.actions.openMenu();
          }

          break;

        default:
          if (!select.state.isOpen && shouldMenuOpen) {
            select.actions.openMenu();
          }

          return;
      }

      event.preventDefault();
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var _this$props9 = this.props,
          select = _this$props9.select,
          disabled = _this$props9.disabled,
          isSearchable = _this$props9.isSearchable,
          shouldMenuOpen = _this$props9.shouldMenuOpen;
      var tag = event.target.tagName;

      if (disabled || !isPrimaryMouseButton(event) && !isTouchEvent(event)) {
        return;
      }

      if (!isSearchable) {
        // Open the menu if the Input isn't searchable, blocking any further
        // attempts to focus the input.
        event.preventDefault();
        this.toggleMenu();
      } else {
        if (select.state.options.length > 0) {
          // Don't let the input blur when we click on random elements inside of
          // the Select component.
          if (tag !== 'INPUT') {
            event.stopPropagation();
            event.preventDefault();
          } // Open the menu and focus it, if the menu is closed and there are options
          // to select.


          if (!select.state.isOpen && shouldMenuOpen) {
            select.actions.openMenu();
          }
        }
      }
    }
  }]);

  return SelectInput;
}(Component), _defineProperty(_class2, "propTypes", {
  styles: Types.func,
  select: SelectModelPropType,

  /** Overridable Component */
  LoadingIndicator: ComponentPropType,
  loadingIndicatorProps: Types.object,

  /** Overridable Component */
  DropdownIndicator: ComponentPropType,
  dropdownIndicatorProps: Types.object,

  /** Overridable Component */
  ClearIndicator: ComponentPropType,
  clearIndicatorProps: Types.object,

  /** Overridable Component */
  Value: ComponentPropType,

  /*
  |---------------------------------------------------------------------------
  | Data Representation
  */

  /** input placeholder - displayed when `value` is falsey */
  placeholder: Types.node,
  // TODO: Implement initial / overriding value

  /** Initial input value */
  value: Types.any,

  /** Enables the ClearButton, for resetting the value */
  isClearable: Types.bool,

  /*
  |---------------------------------------------------------------------------
  | Browser Behaviours
  */

  /** Applies html `name` attr - good behaviour to enforce, and it serves as an ID */
  name: Types.string.isRequired,

  /** Applies instant focus to the input when mounted */
  autoFocus: Types.bool,

  /** Applies html `required` attr - handles multi logic too */
  required: Types.bool,

  /** Disables the SelectControl */
  disabled: Types.bool,

  /** Optional tab index of the control */
  tabIndex: NumOrStringPropType,

  /** Fires when focus is taken off of `SelectControl`: function (event) {} */
  onBlur: Types.func,

  /** Fires when focus is given to `SelectControl`: function (event) {} */
  onFocus: Types.func,

  /** Fires when input is changed: function (event) {} */
  onChange: Types.func,

  /** Intercepts the native `onKeyDown` event on input: function (option, event) {} */
  onKeyDown: Types.func,

  /*
  |---------------------------------------------------------------------------
  | UX Related Behaviours
  */

  /** Blurs the input once a selection is made */
  autoBlur: Types.bool,

  /** Enables search-ahead in the input, otherwise only opens the menu */
  isSearchable: Types.bool,

  /** Always open options menu when Input is focused */
  shouldOpenOnFocus: Types.bool,

  /** Always close options menu when Input is blurred */
  shouldCloseOnBlur: Types.bool,

  /** Whether backspace key removes an option when there is no text input */
  shouldBackspaceRemove: Types.bool,

  /** Whether delete key removes an option when there is no text input */
  shouldDeleteRemove: Types.bool,

  /** Whether escape clears the value when the menu is closed */
  shouldEscapeClearValue: Types.bool,

  /** Whether to treat tabbing out while focused to be value selection (default: true) */
  shouldTabSelectValue: Types.bool,

  /** Whether input is cleared on blur */
  shouldBlurResetInput: Types.bool,

  /** Whether input is cleared when menu is closed through the arrow */
  shouldCloseResetInput: Types.bool,

  /** Close the menu when an option is selected (click/touch) */
  shouldCloseOnSelect: Types.bool,

  /** Whether or not the menu should ever open as a result of interaction with the input */
  shouldMenuOpen: Types.bool,

  /** A callback fired when the input field value has been cleared by clicking the ClearIndicator **/
  onCleared: Types.func
}), _defineProperty(_class2, "defaultProps", {
  LoadingIndicator: LoadingIndicator,
  loadingIndicatorProps: {},
  DropdownIndicator: DropdownIndicator,
  dropdownIndicatorProps: {},
  ClearIndicator: ClearIndicator,
  clearIndicatorProps: {},
  Value: Value,
  placeholder: 'Select...',
  isClearable: true,
  autoFocus: false,
  required: false,
  disabled: false,
  tabIndex: 0,
  onBlur: _.noop,
  onFocus: _.noop,
  onChange: _.noop,
  onKeyDown: _.noop,
  autoBlur: false,
  isSearchable: true,
  shouldMenuOpen: true,
  shouldOpenOnFocus: false,
  shouldCloseOnBlur: true,
  shouldBackspaceRemove: true,
  shouldDeleteRemove: true,
  shouldEscapeClearValue: true,
  shouldTabSelectValue: true,
  shouldBlurResetInput: true,
  shouldCloseResetInput: true,
  shouldCloseOnSelect: true
}), _temp)) || _class) || _class) || _class);
SelectInput.displayName = 'SelectInput';
export default SelectInput;